import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Scissors, Truck, Store } from 'lucide-react';

export function PrepList({ events, dateLabel }) {
  const deliveries = events.filter((e) => e.type === 'delivery' && e.details.status !== 'delivered');
  if (deliveries.length === 0) return null;

  const byVariety = {};
  deliveries.forEach((e) => e.details.items.forEach((i) => { byVariety[i.variety_name] = (byVariety[i.variety_name] || 0) + i.quantity_m2; }));
  const totalM2 = Object.values(byVariety).reduce((a, b) => a + b, 0);
  const pickups = deliveries.filter((e) => e.details.delivery_method === 'pickup').length;
  const trucks = deliveries.length - pickups;

  return (
    <Card className="border-primary/30 bg-primary/5" data-testid="prep-list">
      <CardHeader className="pb-3">
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <Scissors className="h-5 w-5 text-primary" /> Cut list — {dateLabel}
        </CardTitle>
      </CardHeader>
      <CardContent className="grid md:grid-cols-[1fr_auto] gap-6">
        <ul className="divide-y rounded-md border bg-card" data-testid="prep-list-items">
          {Object.entries(byVariety).sort((a, b) => b[1] - a[1]).map(([name, m2]) => (
            <li key={name} className="flex justify-between px-4 py-2.5 text-sm" data-testid={`prep-item-${name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}>
              <span className="font-medium">{name}</span><span className="font-heading font-bold">{m2.toLocaleString()} m²</span>
            </li>
          ))}
          <li className="flex justify-between px-4 py-2.5 text-sm font-bold bg-secondary/40"><span>Total to cut</span><span data-testid="prep-total-m2">{totalM2.toLocaleString()} m²</span></li>
        </ul>
        <div className="flex md:flex-col gap-4 text-sm">
          <div className="flex items-center gap-2" data-testid="prep-delivery-count"><span className="w-9 h-9 rounded-full bg-blue-600 text-white flex items-center justify-center"><Truck className="h-4 w-4" /></span><div><p className="font-heading font-bold text-xl leading-none">{trucks}</p><p className="text-xs text-muted-foreground">{trucks === 1 ? 'delivery' : 'deliveries'}</p></div></div>
          <div className="flex items-center gap-2" data-testid="prep-pickup-count"><span className="w-9 h-9 rounded-full bg-sky-700 text-white flex items-center justify-center"><Store className="h-4 w-4" /></span><div><p className="font-heading font-bold text-xl leading-none">{pickups}</p><p className="text-xs text-muted-foreground">{pickups === 1 ? 'pickup' : 'pickups'}</p></div></div>
        </div>
      </CardContent>
    </Card>
  );
}
